export type AtVirtualClinicKostentraeger =
  | '2' | '3' | '5' | '6' | '7' | '8' | '9' | '40' | '50'
  | '11' | '12' | '13' | '14' | '15' | '16' | '17' | '18' | '19'
  | '1A' | '2A' | '4A' | '4B' | '4C' | '4D' | '4E' | '4F' | '4K'
  | '5A' | '6A' | '7A' | '7C' | '8B' | '8C' | '8D'
  | '79' | 'A1' | 'A2' | 'A3' | 'A4' | 'A5' | 'A6' | 'A7' | 'A8' | 'A9'
  | 'B1' | 'B2' | 'B3' | 'B4' | 'B5' | 'B6' | 'B7' | 'B8' | 'B9'
  | 'G1' | 'G2' | 'G3' | 'G4' | 'G5' | 'G6' | 'G7' | 'G8' | 'G9'
  | 'L1' | 'L2' | 'L3' | 'L4' | 'L5' | 'L6' | 'L7' | 'L8' | 'L9' | 'AN'
  | 'M1' | 'M2' | 'M3' | 'M4' | 'M5' | 'M6'
  | 'S1' | 'S4' | 'S5' | 'S6' | 'S7' | 'S8' | 'S9'
  | 'BN' | 'SL' | 'SN' | 'SZ' | 'UB' | 'UF';

export const AT_VIRTUAL_CLINIC_KOSTENTRAEGER_DISPLAY_NAMES: Record<AtVirtualClinicKostentraeger, string> = {
  '2': 'PVA — Pensionsversicherungsanstalt',
  '3': 'SVS — Unfallversicherungsträger',
  '5': 'BVAEB — Eisenbahn Bergbau',
  '6': 'VAN — Versorgungsanstalt des österr. Notariates',
  '7': 'BVAEB — Öffentlich Bedienstete',
  '8': 'AUVA — Allgemeine Unfallversicherungsanstalt',
  '9': 'BVAEB — Unfallversicherungsträger',
  '40': 'SVS — gewerbliche Wirtschaft',
  '50': 'SVS — Landwirtschaft',
  '11': 'ÖGK Wien',
  '12': 'ÖGK Niederösterreich',
  '13': 'ÖGK Burgenland',
  '14': 'ÖGK Oberösterreich',
  '15': 'ÖGK Steiermark',
  '16': 'ÖGK Kärnten',
  '17': 'ÖGK Salzburg',
  '18': 'ÖGK Tirol',
  '19': 'ÖGK Vorarlberg',
  '1A': 'KFA Wien',
  '2A': 'KF Baden',
  '4A': 'MKF Linz',
  '4B': 'KFG OÖ (Gemeinden)',
  '4C': 'KFL OÖ (Landesbedienstete)',
  '4D': 'LKUF OÖ (Lehrer)',
  '4E': 'KFA Steyr',
  '4F': 'KFA Wels',
  '4K': 'ÄK OÖ (Ärztekammer OÖ)',
  '5A': 'KFA Graz',
  '6A': 'KFA Villach',
  '7A': 'KFA Salzburg',
  '7C': 'KFA Hallein',
  '8B': 'KUF Tirol — Gemeindebeamte',
  '8C': 'KUF Tirol — Landesbeamte',
  '8D': 'KUF Tirol — Landeslehrer',
  '79': 'AMS (Zentrale)',
  'A1': 'AMS Wien',
  'A2': 'AMS Niederösterreich',
  'A3': 'AMS Burgenland',
  'A4': 'AMS Oberösterreich',
  'A5': 'AMS Steiermark',
  'A6': 'AMS Kärnten',
  'A7': 'AMS Salzburg',
  'A8': 'AMS Tirol',
  'A9': 'AMS Vorarlberg',
  'B1': 'MAG Wien',
  'B2': 'BH Niederösterreich',
  'B3': 'BH Burgenland',
  'B4': 'BH Oberösterreich',
  'B5': 'BH Steiermark',
  'B6': 'BH Kärnten',
  'B7': 'BH Salzburg',
  'B8': 'BH Tirol',
  'B9': 'BH Vorarlberg',
  'G1': 'ASG Wien',
  'G2': 'ASG Niederösterreich',
  'G3': 'ASG Burgenland',
  'G4': 'ASG Oberösterreich',
  'G5': 'ASG Steiermark',
  'G6': 'ASG Kärnten',
  'G7': 'ASG Salzburg',
  'G8': 'ASG Tirol',
  'G9': 'ASG Vorarlberg',
  'L1': 'AUSL-J Wien (abrechenbar für LGF)',
  'L2': 'AUSL-J Niederösterreich',
  'L3': 'AUSL-J Burgenland',
  'L4': 'AUSL-J Oberösterreich',
  'L5': 'AUSL-J Steiermark',
  'L6': 'AUSL-J Kärnten',
  'L7': 'AUSL-J Salzburg',
  'L8': 'AUSL-J Tirol',
  'L9': 'AUSL-J Vorarlberg',
  'AN': 'AUSL-N — nicht abrechenbar für Landesfonds',
  'M1': 'BMSGPK (Soziales, Gesundheit, Pflege, Konsumentenschutz)',
  'M2': 'BMI (Inneres)',
  'M3': 'BMJ (Justiz)',
  'M4': 'BMLV (Landesverteidigung)',
  'M5': 'BMBWF (Bildung, Wissenschaft, Forschung)',
  'M6': 'BMK (Klimaschutz, Umwelt, Energie, Mobilität)',
  'S1': 'BSA Ost (Wien, NÖ, Bgld)',
  'S4': 'BSA Oberösterreich',
  'S5': 'BSA Steiermark',
  'S6': 'BSA Kärnten',
  'S7': 'BSA Salzburg',
  'S8': 'BSA Tirol',
  'S9': 'BSA Vorarlberg',
  'BN': 'BGA — Bundesgesundheitsagentur (nicht abrechenbar)',
  'SL': 'Sonstige Kostenträger (abrechenbar für Landesfonds)',
  'SN': 'Sonstige Kostenträger (nicht abrechenbar)',
  'SZ': 'Selbstzahler (inkl. Vollzahler durch private KV)',
  'UB': 'Kostenträger unbekannt',
  'UF': 'Uneinbringliche Forderung (kein Zahler)',
};
